import { render, staticRenderFns } from "./TopicPages.vue?vue&type=template&id=500f03e8&scoped=true&"
import script from "./TopicPages.vue?vue&type=script&lang=js&"
export * from "./TopicPages.vue?vue&type=script&lang=js&"
import style0 from "./TopicPages.vue?vue&type=style&index=0&id=500f03e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f03e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle})
